import {createRouter, createWebHistory} from 'vue-router';
import WelcomePage from './components/WelcomePage.vue';
import SettingsPage from './components/settings/SettingsPage.vue';
import ReportsPage from './components/reports/ReportsPage.vue';
import ScriptsPage from './components/scripts/ScriptsPage.vue';
import NotificationsPage from './components/notifications/NotificationsPage.vue';
import TrackerList from './components/tracker/TrackerList.vue';
import TrackerDetail from './components/tracker/TrackerDetail.vue';
import SubscriptionsPage from './components/subscriptions/SubscriptionsPage.vue';

const routes = [
  {
    path: '/',
    component: WelcomePage,
    name: 'home',
  },
  {path: '/tracker', name: 'trackerList', component: TrackerList},
  {path: '/tracker/:id', name: 'trackerDetail', component: TrackerDetail},
  {path: '/settings', name: 'settings', component: SettingsPage},
  {path: '/reports', name: 'reports', component: ReportsPage},
  {path: '/scripts', name: 'scripts', component: ScriptsPage},
  {
    path: '/notifications',
    name: 'notifications',
    component: NotificationsPage,
  },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: SubscriptionsPage,
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});
export default router;
